// extracted by mini-css-extract-plugin
export default {"content":"ffuGqOdmxA0LQQPTTptD","text":"S9QhirpC0W8cvG7mB2xY","loading":"dgU_aPHRswAwpFu5bVv9","placeHolderShimmer":"Ex8Lj33691WGhC2YJuv2"};